import React, { Component } from "react"
import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags';
import { Link } from "react-router-dom"
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  Input,
  Button,
} from "reactstrap"
import { connect } from "react-redux"
import CurrencyFormat from 'react-currency-format';
import Breadcrumbs from "../../components/Common/Breadcrumb"

//i18n
import { withTranslation } from "react-i18next"
import 'react-date-range/dist/styles.css'; // main style file
import "chartist/dist/scss/chartist.scss";
import "../../assets/scss/chartist.scss";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import TransactionSpineline from "./chart/data/TransactionSpinelinechart"
import TransactionPiechart from "./chart/data/TransactionPiechart";
import Moment from 'react-moment';
import { getAgentAllDeal } from "../../store/actions";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import DealColumnchart from "./chart/data/Dealcolumnchart";
import DealPiechart from "./chart/data/DealPiechart";
import SaveButton from "components/buttons/save";
import { API_URL } from "helpers/app_url";
import axios from "axios";
class DealDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchQuery: "",
      fromDate: "",
      toDate: "",
      filteredTransactions: [],
    };
  }
  componentDidMount() {
    const { onGetAgentAllTransaction } = this.props;
    onGetAgentAllTransaction(localStorage.getItem('userId'));

  }
  componentDidUpdate(prevProps) {
    if (prevProps.alltransactions !== this.props.alltransactions) {
      this.setState({ filteredTransactions: this.props.alltransactions });
    }
  }
  fetchFilteredTransactions = async () => {
    try {
      const { searchQuery, fromDate, toDate, status } = this.state;
      const agentId = localStorage.getItem("userId");
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj.resultData.bearerToken;
      const str = 'Bearer ' + token;
      const response = await axios.get(
        `${API_URL}ClientEngagement/allbyagentfilter`,
        {
          params: {
            agentId,
            filter: searchQuery || "",
            startDate: fromDate || "",
            endDate: toDate || "",
            status: status || "",
          },
          headers: { Authorization: str },
        }
      );

      this.setState({ filteredTransactions: response.data || [] });
    } catch (error) {
      console.error("Error fetching filtered transactions:", error);
    }
  };

  applyLocalFilter = () => {
    const { alltransactions } = this.props;
    const { searchQuery, fromDate, toDate, status } = this.state;

    let filtered = alltransactions;

    if (searchQuery) {
      filtered = filtered.filter((t) =>
        t.contactName.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    if (fromDate) {
      filtered = filtered.filter((t) => new Date(t.startDate) >= new Date(fromDate));
    }

    if (toDate) {
      filtered = filtered.filter((t) => new Date(t.startDate) <= new Date(toDate));
    }

    if (status) {
      filtered = filtered.filter((t) => t.clientEngagementStatus === Number(status));
    }

    this.setState({ filteredTransactions: filtered });
  };

  handleSearch = (e) => {
    this.setState({ searchQuery: e.target.value }, this.applyLocalFilter);
  };

  handleDateChange = (date, field) => {
    this.setState({ [field]: date ? date[0] : "" }, this.applyLocalFilter);
  };

  handleStatusChange = (e) => {
    this.setState({ status: e.target.value }, this.applyLocalFilter);
  };

  getBuyerType = (type) => {
    if (type == 1)
      return 'Looking to Rent';
    else if (type == 2)
      return 'Looking to Buy';

  }

  getSellerType = (type) => {
    if (type == 1)
      return 'Looking to Sell';
    else if (type == 2)
      return 'Looking to Lease';

  }
  getCommType = (type) => {
    if (type == 3)
      return 'Fixed';
    else if (type == 4)
      return '%';

  }
  render() {
    const { alltransactions } = this.props;
    const { filteredTransactions, searchQuery, fromDate, toDate, status } = this.state;
    
    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Create Template | Realty Space</title>
          </MetaTags>
          <Container fluid className=" ps-0 pe-0">
            {/* Render Breadcrumb */}

            <Row className="project-header">
              <Col sm="12">
                <Breadcrumbs
                  title={this.props.t("Reports")}
                  breadcrumbItem={this.props.t("Deals")}
                />
              </Col>
              {/* <Col sm="6">
              
              </Col> */}
            </Row>
            <Card>
              <CardBody>
                <Row>

                  <Col sm="6">
                    <h4 style={{ textAlign: "center" }}>Monthly Deals Report</h4>
                    <DealColumnchart />

                  </Col>

                  <Col sm="6">

                    <h4 style={{ textAlign: "center" }}>Types of Deals</h4>
                    <DealPiechart />



                  </Col>
                </Row>
              </CardBody>
            </Card>


            <Row>
              <Col sm="12">
                <Card>
                  <CardBody>
                    <Row className="mb-3">
                    <Col sm="2"></Col>
                      <Col sm="4">
                      <div className="input-group position-relative">
                        <Input
                          type="text"
                          placeholder="Search By Name"
                          value={searchQuery}
                          onChange={this.handleSearch}
                        />

<span className="input-group-text search-btn" id="basic-addon1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-search"
                              viewBox="0 0 16 16"
                            >
                              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                            </svg>
                          </span>
                          </div>
                      </Col>
                      <Col sm="2">
                        <Flatpickr
                          className="form-control"
                          placeholder="From"
                          value={fromDate}
                          onChange={(date) => this.handleDateChange(date, "fromDate")}
                          options={{ dateFormat: "Y-m-d" }}
                        />
                      </Col>
                      <Col sm="2">
                        <Flatpickr
                          className="form-control"
                          placeholder="To"
                          value={toDate}
                          onChange={(date) => this.handleDateChange(date, "toDate")}
                          options={{ dateFormat: "Y-m-d" }}
                        />
                      </Col>
                      
                      <Col sm="1">
                        <Button color="primary" onClick={this.fetchFilteredTransactions}>
                         Search Now
                        </Button>
                      </Col>
                    </Row>
                    <div className="clearfix"></div>

                  
                  <DataTable className="" stripedRows value={filteredTransactions} paginator rows={10} rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500]} currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries " paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown   " tableStyle={{ minWidth: '50rem' }}   >
                    <Column field="startDate" header="Start Date" body={(rowData) => (
                      rowData.startDate ? <Moment format="D MMM YY">{rowData.startDate}</Moment> : ''
                    )}></Column>
                    <Column field="contactName" header="Client Name"></Column>
                    <Column field="contactName" header="Type" body={(rowData) => {
                      if (rowData.isBuyer) return `Buyer ${rowData.buyerType ? `- ${this.getBuyerType(rowData.buyerType)}` : ""}`;
                      if (rowData.isSeller) return `Seller ${rowData.sellerType ? `- ${this.getSellerType(rowData.sellerType)}` : ""}`;
                      if (rowData.isInvestor) return "Investor";
                      return "N/A";
                    }} />

                    <Column field="closingDate" header="Closing Date" body={(rowData) => (
                      rowData.closingDate ? <Moment format="D MMM YY">{rowData.closingDate}</Moment> : ''
                    )}></Column>
                    <Column field="eventDescription" header="Transaction Amount" body={(rowData) => (
                      <CurrencyFormat value={rowData.transactionAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                    )}></Column>
                    <Column field="commissionType" header="Commission Type" body={(rowData) => {
                      return this.getCommType(rowData.commissionTypeId)
                    }} />
                    <Column field="eventDescription" header="Comission" body={(rowData) => (
                      <CurrencyFormat value={rowData.commissionValue} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                    )}></Column>
                    <Column field="clientEngagementStatus" header="Status " body={(rowData) => {
                      if (rowData.clientEngagementStatus === 1) return `In-progress`;
                      if (rowData.clientEngagementStatus === 2) return `Completed`;
                      if (rowData.clientEngagementStatus === 3) return "Cancelled ";
                      return "N/A";
                    }} />

                    <Column
                      field="clientSourceId"
                      header=""
                      body={(rowData) => (
                        <Link to={`/clients/dashbord/${rowData.clientId}/${rowData.clientGuid}`}>
                          Go to client
                        </Link>
                      )}
                    />
                  </DataTable>
                </CardBody>
              </Card>
            </Col>
          </Row>


        </Container>


      </div>
      </React.Fragment >
    )
  }



}


DealDashboard.propTypes = {
  t: PropTypes.any,
  onGetAgentAllTransaction: PropTypes.func,
  alltransactions: PropTypes.array,
  loading: PropTypes.object


}
const mapStateToProps = ({ Transaction }) => (
  {

    alltransactions: Transaction.alltransactions,
    loading: Transaction.loading

  })
const mapDispatchToProps = dispatch => ({
  onGetAgentAllTransaction: (agentId) => dispatch(getAgentAllDeal(agentId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DealDashboard))